import React from "react";
import { Switch, Route } from "react-router-dom";

import UserDeactivation from "../common/userDeactivation/index.jsx";

import PcmpAuth from "../../hoc/PcmpAuth";
import Dashboard from "./dashboard";
// import PurchaseOrders from "./purchaseOrders";
import PurchaseOrderDashboard from "../common/PurchaseOrderIndex/PurchaseOrderDashboard";
import LineItems from "./lineItems";
import BatchItems from "./batchItems";
import POBatchItems from "./batchItems/poBatchItems";
import CmoPurchaseOrder from "./purchaseOrders/viewPurchaseOrder/purchaseOrder";
import TeamMembers from "../common/teamMembers/TeamMembers";
import ManageMembers from "./manageMembers";
import rolesAndAccessDashboard from "../common/rolesAndAccess/rolesAndAccessDashboard";
import CmoViewLineItem from "./purchaseOrders/viewPurchaseOrder/lineItems";
import ShortFalls from "./shortFalls";
import Reports from "./reports";
import Settings from "./settings";

import NotFound from "../../notFound/NotFound";
import CmoLayout from "../layout";
// import GRNReceipts from '../common/grnReceipts';
import GRNReceipts from "../common/grnReceipts/GrnAccess";

import UserProfile from "../common/profile/user";
import OrgDetails from "../common/profile/organization";
import WIPComponent from "../common/wip";
import DeliveryScheduleDetails from "../common/sasl/deliverScheduleDetails";

import SASLIndex from "../common/sasl/scheduleAgreements/index";
import SAAuditIndex from "../common/reports/saAudit";

/* Quality Event import */
import QualityEventIndex from "../common/qualityEvents/index";

import BatchesDetails from "../common/sasl/batchesDetails";
import ProjectsDashboard from "../common/projectsDashboard/index.jsx";
import PendingDashboard from "../common/projectsDashboard/PendingDashboard.jsx";
import ProjectDeliverables from "../common/projectsDashboard/ProjectDetails/ProjectDeliverables.jsx";
import StructuredData from "../common/projectsDashboard/Reports/StructuredData/StructuredData.jsx";
import ForecastScheduleIndex from "../common/ForecastSchedule/ForecastScheduleIndex.jsx";
import FTEBudget from "../common/projectsDashboard/analytics/FTEBudget.jsx";
import TasksDashboard from "../common/projectsDashboard/tasksDashboard/TasksDashboard.jsx";
import POLineItemDashboard from "../common/purchaseOrderLineItem/POLineItemDashboard.jsx";
import AuditReport from "../common/POAuditReport/AuditReport.jsx";
import PurchaseOrderTabs from "../common/PurchaseOrderIndex/PurchaseOrderTabs.jsx";
import InventoryStatusDashboard from "../common/InventoryStatus/InventoryStatusDashboard";
import ProductDevelopment from "../common/ProjectDevelopment/index.jsx";
import ProductDevelopmentStepper from "../common/ProjectDevelopment/Stepper/ProductDevelopmentStepper";

import ViewComponentAllocation from "../pharmaCo/viewComponentAllocation";
import ViewDetailedComponentAllocation from "../pharmaCo/viewComponentAllocation/ViewDetailAllocation";
import ViewBatchComponentAllocation from "../pharmaCo/viewComponentAllocation/ViewBatchDetails";
import PurchaseOrderDashboardIndex from '../common/PurchaseOrderDashbaordIndex/PurchaseOrderTabs'
import UploadPOs from '../common/PurchaseOrderDashbaordIndex/UploadPOs';
import InactivePODashboard from '../common/inactivePODashboard';
import PODetails from '../common/inactivePODashboard/PODetails';
import NotificationsDashboard from '../common/NotificationsDashboard/NotificationsDashboard';
import ManageNotifications from '../common/NotificationsDashboard/ManageNotifications';
import ManageDistributionList from '../common/NotificationsDashboard/ManageDistributionList';
// import ReasonCodeDashboard from "../common/manageReasonCodeDashboard/ReasonCodeDashboard";
// import MaterialDetailsDashboard from "../common/MaterialDetailsDashboard/MaterialDetailsDashboard";
// import BrandDetailsDashboard from "../common/BrandDetailsDashboard/BrandDetailsDashboard.jsx";
import BrandDetailsDashboard from "../common/BrandDetails/BrandDetailsDashboard.jsx";
import ConfigProductDetails from "../pharmaCo/ConfigProductDetails/ConfigProductDetails.jsx";
import DigitizationDashboard from "../common/digitizationDashboard";
// import SponsorNetworkTabs from "../common/SponsorNetworkTabs/SponsorNetworkTabs";

import DailyOperationsDashboard from "../common/dailyOperations";

const PcmpCmsRoutes = () => (
  <CmoLayout>
    <Switch>
      <Route
        exact
        name="Projects Dashboard"
        path="/pcmp/cmo/:roleName/:organizationName/:ecosystemId/projectsdashboard"
        component={ProjectsDashboard}
        // component={Dashboard}
      />

      <Route
        exact
        name="Projects Dashboard"
        path="/pcmp/cmo/:roleName/:organizationName/:ecosystemId/tasksDashboard"
        component={TasksDashboard}
        // component={Dashboard}
      />

      <Route
        exact
        name="Project Details"
        path="/pcmp/cmo/:roleName/:organizationName/:ecosystemId/projectsdashboard/pendingitems"
        component={PendingDashboard}
      />

      <Route
        exact
        name="Project Details"
        path="/pcmp/cmo/:roleName/:organizationName/:ecosystemId/project/:projectName"
        component={ProjectDeliverables}
      />

      <Route
        exact
        name="Project Details"
        path="/pcmp/cmo/:roleName/:organizationName/:ecosystemId/projectsdashboard/structuredData"
        component={StructuredData}
      />

      <Route
        exact
        name="Project Details"
        path="/pcmp/cmo/:roleName/:organizationName/:ecosystemId/projectsdashboard/FTE-Budget"
        component={FTEBudget}
      />

      <Route
        exact
        name="PCMP CMO Dashboard"
        path="/pcmp/cmo/:roleName/:organizationName/:ecosystemId/dashboard"
        component={PcmpAuth(Dashboard, "CMO")}
      />
      <Route
        exact
        name="PCMP Purchase Orders"
        path="/pcmp/cmo/:roleName/:organizationName/:ecosystemId/purchaseorders"
        component={PcmpAuth(PurchaseOrderTabs, "CMO")}
        // component={PcmpAuth(PurchaseOrderDashboardIndex, "CMO")}
      />
      <Route
        exact
        name="PCMP Purchase Orders"
        path="/pcmp/cmo/:roleName/:organizationName/:ecosystemId/purchaseorderManagement"
        component={PcmpAuth(PurchaseOrderDashboardIndex, "CMO")}
      />
      <Route
        exact
        name="Inactive POs"
        path="/pcmp/cmo/:roleName/:organizationName/:ecosystemId/inactivePOs"
        component={PcmpAuth(InactivePODashboard, "CMO")}
      />
      <Route
        exact
        name="PO Details"
        path="/pcmp/cmo/:roleName/:organizationName/:ecosystemId/inactivePOs/poDetails"
        component={PcmpAuth(PODetails, "CMO")}
      />
      <Route
        exact
        name="Upload POs"
        path="/pcmp/cmo/:roleName/:organizationName/:ecosystemId/uploadPOs"
        component={UploadPOs}
      />
      <Route
        exact
        name="PCMP Purchase Orders"
        path="/pcmp/cmo/:roleName/:organizationName/:ecosystemId/purchaseorders/lineitems"
        component={PcmpAuth(POLineItemDashboard, "CMO")}
      />
      <Route
        exact
        name="PCMP PO Audit Report"
        path="/pcmp/cmo/:roleName/:organizationName/:ecosystemId/purchaseorders/purchaseOrderAuditReport"
        component={AuditReport}
      />

      <Route
        exact
        name="PCMP All Line Items"
        path="/pcmp/cmo/:roleName/:organizationName/:ecosystemId/lineitems"
        component={PcmpAuth(LineItems, "CMO")}
      />
      <Route
        exact
        name="PCMP All Batch Items"
        path="/pcmp/cmo/:roleName/:organizationName/:ecosystemId/batches"
        component={PcmpAuth(BatchItems, "CMO")}
      />
      <Route
        exact
        name="CMo Purchase Order"
        path="/pcmp/cmo/:roleName/:organizationName/:ecosystemId/purchaseorderdetails/:purchaseOrderNumber"
        component={PcmpAuth(CmoPurchaseOrder, "CMO")}
      />
      <Route
        exact
        name="PCMP All Batch Items for a Purchase Order"
        path="/pcmp/cmo/:roleName/:organizationName/:ecosystemId/:purchaseOrderNumber/pobatchitems"
        component={PcmpAuth(POBatchItems, "CMO")}
      />
      <Route
        exact
        name="CMO Manage Members"
        path="/pcmp/cmo/:roleName/:organizationName/:ecosystemId/managemembers"
        component={PcmpAuth(ManageMembers, "CMO")}
      />
      <Route
        exact
        name="CMO Roles And Access"
        path="/pcmp/cmo/:roleName/:organizationName/:ecosystemId/rolesandaccess"
        component={PcmpAuth(rolesAndAccessDashboard, "CMO")}
      />
      <Route
        exact
        name="CMO Team members"
        path="/pcmp/cmo/:roleName/:organizationName/:ecosystemId/TeamMembers"
        component={PcmpAuth(TeamMembers, "CMO")}
      />
      <Route
        exact
        name="CMO Inventory status"
        path="/pcmp/cmo/:roleName/:organizationName/:ecosystemId/inventoryStatus"
        component={PcmpAuth(InventoryStatusDashboard, "CMO")}
      />
      <Route
        exact
        name="Product Development"
        path="/pcmp/cmo/:roleName/:organizationName/:ecosystemId/productdevelopment"
        component={PcmpAuth(ProductDevelopment, "CMO")}
      />
      <Route
        exact
        name="Add New Project"
        path="/pcmp/cmo/:roleName/:organizationName/:ecosystemId/productdevelopment/add-new-project"
        component={PcmpAuth(ProductDevelopmentStepper, "CMO")}
      />
      {/* Editing carries the project id in the URL rather than in navigation
          state, so a refresh or a shared link still opens the edit screen. */}
      <Route
        exact
        name="Edit Project"
        path="/pcmp/cmo/:roleName/:organizationName/:ecosystemId/productdevelopment/edit-project/:collabrixProjectID"
        component={PcmpAuth(ProductDevelopmentStepper, "CMO")}
      />
      <Route
        exact
        name="Edit Campaign"
        path="/pcmp/cmo/:roleName/:organizationName/:ecosystemId/productdevelopment/edit-campaign/:collabrixProjectID"
        component={PcmpAuth(ProductDevelopmentStepper, "CMO")}
      />
      <Route
        exact
        name="Settings"
        path="/pcmp/cmo/:roleName/:organizationName/:ecosystemId/settings"
        component={PcmpAuth(Settings, "CMO")}
      />

      <Route
        exact
        name="CMO Line Item"
        path="/pcmp/cmo/:roleName/:organizationName/:ecosystemId/lineitem/:purchaseOrderNumber/:schrockenPOLineID/:lineItemNumber"
        component={PcmpAuth(CmoViewLineItem, "CMO")}
      />
      <Route
        exact
        name="CMO Short Falls"
        path="/pcmp/cmo/:roleName/:organizationName/:ecosystemId/shortFalls"
        component={PcmpAuth(ShortFalls, "CMO")}
      />

      <Route
        exact
        name="CMO GRN Receipts"
        path="/pcmp/cmo/:roleName/:organizationName/:ecosystemId/GRNReceipts"
        // component={PcmpAuth(GRNReceipts, 'CMO')}
        component={GRNReceipts}
      />

      <Route
        exact
        name="UserDeactivation"
        path="/pcmp/cmo/:roleName/:organizationName/:ecosystemId/userdeactivate"
        // component={PcmpAuth(GRNReceipts, 'CMO')}
        component={UserDeactivation}
      />

      {/* <Route
        exact
        name='SASL Test'
        path='/pcmp/cmo/:roleName/:organizationName/:ecosystemId/testSASL'
        // component={PcmpAuth(GRNReceipts, 'CMO')}
        component={SASLIndex}
      /> */}
      <Route
        exact
        name="Reports"
        path="/pcmp/cmo/:roleName/:organizationName/:ecosystemId/reports"
        component={PcmpAuth(Reports, "CMO")}
      />
      {/* View component allocation route */}
      <Route
        exact
        name="View Component Allocation"
        path="/pcmp/cmo/:roleName/:organizationName/:ecosystemId/viewComponentAllocation"
        component={PcmpAuth(ViewComponentAllocation, "CMO")}
      />
      {/* View detailed component allocation page route */}
      <Route
        exact
        name="View Component Allocation"
        path="/pcmp/cmo/:roleName/:organizationName/:ecosystemId/viewDetailedComponentAllocation"
        component={PcmpAuth(ViewDetailedComponentAllocation, "CMO")}
      />
      {/* View batches component allocation page route */}
      <Route
        exact
        name="View Component Allocation"
        path="/pcmp/cmo/:roleName/:organizationName/:ecosystemId/viewBatchComponentAllocation"
        component={PcmpAuth(ViewBatchComponentAllocation, "CMO")}
      />
      <Route
        exact
        name="SA Audit Reports"
        path="/pcmp/cmo/:roleName/:organizationName/:ecosystemId/sa-audit-reports"
        component={SAAuditIndex}
      />

      {/* Quality Event  */}
      <Route
        exact
        name="Quality Events"
        path="/pcmp/cmo/:roleName/:organizationName/:ecosystemId/quality events"
        component={QualityEventIndex}
      />

      <Route
        exact
        name="Profile Page"
        path="/pcmp/cmo/:roleName/:organizationName/:ecosystemId/userProfile"
        // component={PcmpAuth(GRNReceipts, 'CMO')}
        component={UserProfile}
      />

      <Route
        exact
        name="Organization Profile Page"
        path="/pcmp/cmo/:roleName/:organizationName/:ecosystemId/orgProfile"
        // component={PcmpAuth(GRNReceipts, 'CMO')}
        component={OrgDetails}
      />
      <Route
        exact
        name="Products"
        path="/pcmp/cmo/:roleName/:organizationName/:ecosystemId/products"
        component={ConfigProductDetails}
      />
      <Route
        exact
        name="Brand Details"
        path="/pcmp/cmo/:roleName/:organizationName/:ecosystemId/branddetails"
        component={BrandDetailsDashboard}
      />
      {/* <Route
        exact
        name="Sponsor Network"
        path="/pcmp/cmo/:roleName/:organizationName/:ecosystemId/sponsornetwork"
        component={SponsorNetworkTabs}
      /> */}

      {/* <Route
        exact
        name="Manage Reason Codes"
        path="/pcmp/cmo/:roleName/:organizationName/:ecosystemId/managereasoncodes"
        // component={PcmpAuth(GRNReceipts, 'CMO')}
        component={ReasonCodeDashboard}
      /> */}
      {/* <Route
        exact
        name="Material Details"
        path="/pcmp/cmo/:roleName/:organizationName/:ecosystemId/materialdetails"
        // component={PcmpAuth(GRNReceipts, 'CMO')}
        component={MaterialDetailsDashboard}
      /> */}
      <Route
        exact
        name="Schedule Agreements"
        path="/pcmp/cmo/:roleName/:organizationName/:ecosystemId/schedule agreements"
        component={SASLIndex}
      />

      {/* SA SL test screens route */}
      <Route
        exact
        name="Schedule Line Details"
        path="/pcmp/cmo/:roleName/:organizationName/:ecosystemId/sasl/:schrockenDeliveryScheduleID"
        component={DeliveryScheduleDetails}
      />

      <Route
        exact
        name="Help"
        path="/pcmp/cmo/:roleName/:organizationName/:ecosystemId/help"
        component={WIPComponent}
      />
      <Route
        exact
        name="Switch Ecosystems"
        path="/pcmp/cmo/:roleName/:organizationName/:ecosystemId/switch ecosystem"
        component={WIPComponent}
      />

      {/* Batch Dashboard */}
      <Route
        exact
        name="PCMP All Batches"
        path="/pcmp/cmo/:roleName/:organizationName/:ecosystemId/fgBatches"
        component={BatchesDetails}
      />

      <Route
        exact
        name="PCMP All Batches"
        path="/pcmp/cmo/:roleName/:organizationName/:ecosystemId/fgBatches/:batchNo"
        component={BatchesDetails}
      />

      <Route
        exact
        name="Schedule Agreements"
        path="/pcmp/cmo/:roleName/:organizationName/:ecosystemId/forecastSchedule"
        component={ForecastScheduleIndex}
      />

      <Route
        exact
        name="Digitization Dashboard"
        path="/pcmp/cmo/:roleName/:organizationName/:ecosystemId/digitizationdashboard"
        component={DigitizationDashboard}
      />

      <Route
        exact
        name="Notifications"
        path="/pcmp/cmo/:roleName/:organizationName/:ecosystemId/notifications"
        component={NotificationsDashboard}
      />

      <Route
        exact
        name="Manage Notifications"
        path="/pcmp/cmo/:roleName/:organizationName/:ecosystemId/manage-notifications"
        component={ManageNotifications}
      />

      <Route
        exact
        name="Manage Distribution List"
        path="/pcmp/cmo/:roleName/:organizationName/:ecosystemId/manage-distribution-list"
        component={ManageDistributionList}
      />

      <Route
        exact
        name="Daily Operations Dashboard"
        path="/pcmp/cmo/:roleName/:organizationName/:ecosystemId/dailyoperationsdashboard"
        component={DailyOperationsDashboard}
      />

      <Route exact name="404 Not Found" component={NotFound} />
    </Switch>
  </CmoLayout>
);

export default PcmpCmsRoutes;
